import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { ActivoFijoModel } from 'src/app/models/activoFijo.model';
import { reporteActivoFijoModel } from 'src/app/models/reporteActivoFijo.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { valorModel } from 'src/app/models/valor-model';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-generar-reportes-activos-fijos',
  templateUrl: './generar-reporte-activos-fijos.component.html',
  styleUrls: ['./../generar-reporte.component.scss']
})

export class GenerarReporteActivosFijosComponent implements OnInit {

  @Input() tipoActivoFijo: ActivoFijoModel[];
  @Input() reporteActivoFijo: reporteActivoFijoModel[];

  public usuarios: string;
  public claseActivoFijo: valorModel[];
  public descripcionActivoFijo: valorModel[];
  public filtroUsuario: string;
  public filtroDocumento: string;
  public filtroTipoActivoFijo: string;
  public filtroTieneSerial: string;
  public filtroNumeroSerial: string;
  public filtroActivoFijoMen: string;
  public filtroTienePlacaInventario: string;
  public filtroNumeroPlacaInventario: string;
  public filtroClaseActivoFijo: string;
  public filtroDescripcionActivoFijo: string;
  // public filtroFechaFin?: string;
  // public filtroFechaInicio?: string;
  public filtroFechaInicio: Date;
  public filtroFechaFin: Date;
  public validar = true;
  public datosArchivo: any;
  public habilitarDescripcion = true;
  public placeholderDate: string;

  constructor(
    private global: GlobalService,
    private urlService: UrlService,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private utilService: UtilService
  ) { }

  ngOnInit() {
    this.placeholderDate = ConstantesService.SELECCION_FECHA;
    this.obtenerTipoUsuario();
    this.getTipoActivoFijo();
    this.consultarClaseActivoFijo();
  }

  /**
   * Método que Consulta los dominios que se relacionen con el nombre 'TipoUsuario'
   */
  public obtenerTipoUsuario() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoUsuario']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.usuarios = data;
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible Obtener tipo Usuario');
      }
    );
  }

  /**
   * Método que Consulta los dominios que se relacionen con el nombre 'TipoActivoFijo'
   */
  public getTipoActivoFijo() {
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoActivoFijo']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.getGenerico(url).subscribe(
      data => {
        this.tipoActivoFijo = data;
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible Cargar los Activos Fijos');
      }
    );
  }

  /**
   * Método que consulta las Clases de activos fijos exitentes
   */
  consultarClaseActivoFijo() {
    const serviceProvider = 'ObtenerTipoActivoFijo';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url).subscribe(
      data => {
        this.claseActivoFijo = data;
      }, err => {
        this.cathException('No es posible Cargar las clase de activo fijo');
      }
    );
  }

  /**
   * Realiza la una consulta de las descripciones que tengan relacion
   * con la clase de activofijo seleccionado por el usuario
   * @param event: any Obtiene la clase de activo fijo seleccionada por el usuario
   */
  consultarDescripcion(event: any) {
    if (event === undefined || event === 'undefined') {
      this.habilitarDescripcion = true;
    } else {
      this.spinner.show();
      const serviceProvider = 'ObtenerDescripcionActivoFijo';
      const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
      this.global.postGenerico(url, event).subscribe(
        data => {
          this.descripcionActivoFijo = data;
          this.spinner.hide();
          this.habilitarDescripcion = false;
        }, err => {
          this.cathException('No es posible Cargar las descripciones');
        }
      );
    }
  }

  /**
   * Método que vuelve todos los filtros undefined solamente si el tipo de Usuario a cambiado
   */
  borrarDatos() {
    this.filtroActivoFijoMen = undefined;
    this.filtroClaseActivoFijo = undefined;
    this.filtroDescripcionActivoFijo = undefined;
    this.filtroDocumento = undefined;
    this.filtroFechaFin = undefined;
    this.filtroFechaInicio = undefined;
    this.filtroNumeroPlacaInventario = undefined;
    this.filtroNumeroSerial = undefined;
    this.filtroTienePlacaInventario = undefined;
    this.filtroTieneSerial = undefined;
    this.filtroTipoActivoFijo = undefined;
  }

  /**
   * Valida si el campo Activo Fijo Men a sido seleccinado 'SI', para hacer visible
   * campos nuevos y Limpiar algunos campos
   */
  borrarContenido() {
    if (this.filtroActivoFijoMen === '0' || this.filtroActivoFijoMen === 'undefined' || this.filtroActivoFijoMen === undefined) {
      this.filtroTienePlacaInventario = undefined;
      this.filtroNumeroPlacaInventario = undefined;
      this.filtroClaseActivoFijo = undefined;
      this.filtroDescripcionActivoFijo = undefined;
    }
    if (this.filtroActivoFijoMen === '1') {
      this.filtroNumeroSerial = undefined;
      this.filtroTieneSerial = undefined;
    }
  }

  /**
   * Método que verifica que el campo 'Tiene Placa Inventario' se encuentre correctamente
   * validado para utilizar el numero de placa con filtro para realizar la consulta necesaria
   */
  cambioPlaca() {
    if (this.filtroTienePlacaInventario === '0' || this.filtroTienePlacaInventario === 'undefined'
      || this.filtroTienePlacaInventario === undefined) {
      this.filtroNumeroPlacaInventario = undefined;
    }
  }

  /**
   * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
   * al BACKEND y obtiene el resultado de la consulta deseada
   */
  GenerarReporteActivosFijos() {
    this.validacion();

    if (!this.validar) {
      this.spinner.show();
      if (this.filtroDocumento && this.filtroDocumento.length > 0 && !/^([A-Z0-9])*$/.test(this.filtroDocumento)) {
        this.cathException('Por favor ingrese nuevamente un “Número de identificación del usuario ”');
        this.cathException('La información ingresada en “Número de identificación del usuario”'
          + ' no corresponde con lo solicitado, por favor verifique');
        document.getElementById('numeroDocumento').focus();
        return;
      }
      if (this.filtroNumeroSerial && this.filtroNumeroSerial.length > 0 && !/^([A-Z0-9])*$/.test(this.filtroNumeroSerial)) {
        this.cathException('Por favor ingrese nuevamente un “Número serial”');
        this.cathException('La información ingresada en “Número serial”'
          + ' no corresponde con lo solicitado, por favor verifique');
        document.getElementById('numeroSerial').focus();
        return;
      }
      if (this.filtroNumeroPlacaInventario && this.filtroNumeroPlacaInventario.length > 0
        && !/^([A-Z0-9])*$/.test(this.filtroNumeroPlacaInventario)) {
        this.cathException('Por favor ingrese nuevamente un “Número de Placa de inventario”');
        this.cathException('La información ingresada en “Número de Placa de inventario”'
          + ' no corresponde con lo solicitado, por favor verifique');
        document.getElementById('numeroPlaca').focus();
        return;
      }
      // this.handlerDatePickeRInicio(this.filtroFechaInicio);
      // this.handlerDatePickeRFin(this.filtroFechaInicio);
      const filtros = {
        filtroUsuario: this.filtroUsuario,
        filtroDocumento:
          this.utilService.validarCamposObligatorios(this.filtroDocumento) ? this.filtroDocumento : undefined,
        filtroTipoActivoFijo:
          this.utilService.validarCamposObligatorios(this.filtroTipoActivoFijo) ? this.filtroTipoActivoFijo : undefined,
        filtroTieneSerial:
          this.utilService.validarCamposObligatorios(this.filtroTieneSerial) ? this.filtroTieneSerial : undefined,
        filtroNumeroSerial:
          (this.utilService.validarCamposObligatorios(this.filtroTieneSerial) && this.filtroTieneSerial === '1')
            ? this.filtroNumeroSerial : undefined,
        filtroActivoFijoMen: this.utilService.validarCamposObligatorios(this.filtroActivoFijoMen)
          ? this.filtroActivoFijoMen : undefined,
        filtroClaseActivoFijo:
          (this.utilService.validarCamposObligatorios(this.filtroActivoFijoMen) && this.filtroActivoFijoMen === '1'
            && this.utilService.validarCamposObligatorios(this.filtroClaseActivoFijo))
            ? this.filtroClaseActivoFijo : undefined,
        filtroDescripcionActivoFijo:
          (this.utilService.validarCamposObligatorios(this.filtroActivoFijoMen) && this.filtroActivoFijoMen === '1'
            && this.utilService.validarCamposObligatorios(this.filtroClaseActivoFijo)
            && this.utilService.validarCamposObligatorios(this.filtroDescripcionActivoFijo))
            ? this.filtroDescripcionActivoFijo : undefined,
        filtroTienePlacaInventario:
          (this.utilService.validarCamposObligatorios(this.filtroActivoFijoMen) && this.filtroActivoFijoMen === '1'
            && this.utilService.validarCamposObligatorios(this.filtroTienePlacaInventario))
            ? this.filtroTienePlacaInventario : undefined,
        filtroNumeroPlacaInventario:
          (this.utilService.validarCamposObligatorios(this.filtroActivoFijoMen) && this.filtroActivoFijoMen === '1'
            && this.utilService.validarCamposObligatorios(this.filtroTienePlacaInventario) 
            && this.filtroTienePlacaInventario === '1' && this.utilService.validarCamposObligatorios(this.filtroNumeroPlacaInventario))
            ? this.filtroNumeroPlacaInventario : undefined,
        filtroFechaInicio: this.filtroFechaInicio,
        filtroFechaFin: this.filtroFechaFin
      };

      const serviceProvider = 'reporteActivosFijos';
      const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
      this.global.postGenerico(url, filtros).subscribe(
        data => {
          this.datosArchivo = data;
          this.spinner.hide();
          this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
          this.descargarArchivo();
        }, err => {
          if (err.status === 500) {
            this.cathException(err.error.message);
          } else {
            this.cathException('El reporte no se ha podido generar');
          }
        }
      );
    }
  }

  /**
   * Método que convierte el archivo Excel y realiza la descarga del mismo
   */
  descargarArchivo() {
    ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      , this.datosArchivo.nombre, this.datosArchivo.archivo);

    this.spinner.hide();
  }

  /**
   * Método que valida los campos Obligatorios para el cual habilitar el botón 'Generar Reporte'
   */
  validacion() {
    
	  if (!this.utilService.validarCamposObligatorios(this.filtroFechaInicio)
		|| !this.utilService.validarCamposObligatorios(this.filtroFechaFin)
		|| !this.utilService.validarCamposObligatorios(this.filtroUsuario)) {
		this.validar = true;
	  } else {
		this.validar = false;
	  }
  }

  /**
   * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
   * @param event resive la fecha seleccionada por el usuario
   */
  // public handlerDatePickeRInicio(event) {
  //   this.filtroFechaInicio = this.utilService.convertirFechaConcatenada(event);
  // }

  /**
   * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
   * @param event resive la fecha seleccionada por el usuario
   */
  // public handlerDatePickeRFin(event) {
  //   this.filtroFechaFin = this.utilService.convertirFechaConcatenada(event);
  // }

  /**
   * Método de control de Excepciones
   * @param error                 mensaje saliente respecto al error ocurrido
   * @param err: HttpResponseBase Tipo de error
   */
  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }
}
